module.exports = __webpack_public_path__ + "img/Table-Tennis.4ebba1a9.png";